/* Section: cart-drawer — subscribes to TPHCart, renders items, handles
   open/close, quantity changes, remove. Opens on any [data-open-cart]
   click and on the "cart:open" custom event (dispatched after add-to-cart). */
(() => {
  const drawer = document.querySelector('[data-section="cart-drawer"]');
  if (!drawer) return;

  const scrim = document.querySelector('[data-cart-scrim]');
  const body = drawer.querySelector('[data-cart-body]');
  const foot = drawer.querySelector('[data-cart-foot]');
  const closeBtn = drawer.querySelector('.cart-drawer__close');
  const titleCount = drawer.querySelector('[data-cart-title-count]');
  const shipWrap = drawer.querySelector('[data-cart-ship]');

  const fmt = (n) => `$${Number(n).toFixed(2)}`;
  const esc = (s) => String(s)
    .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;").replace(/'/g, "&#39;");

  function open() {
    drawer.classList.add('cart-drawer--open');
    scrim?.classList.add('cart-scrim--open');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    drawer.classList.remove('cart-drawer--open');
    scrim?.classList.remove('cart-scrim--open');
    document.body.style.overflow = '';
  }

  // wire all open triggers
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-open-cart]');
    if (trigger) { e.preventDefault(); open(); }
  });
  closeBtn?.addEventListener('click', close);
  scrim?.addEventListener('click', close);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  document.addEventListener('cart:open', open);

  // render whenever the cart changes
  const store = window.TPHCart;
  if (!store) { console.warn('[cart-drawer] TPHCart not loaded'); return; }

  store.subscribe((state) => {
    const count = store.count();
    if (titleCount) titleCount.textContent = count ? `${count} item${count === 1 ? '' : 's'}` : '';

    if (shipWrap) {
      const threshold = store.freeShipQty();
      const pct = Math.min(100, (count / threshold) * 100);
      const done = count >= threshold;
      const left = Math.max(0, threshold - count);
      shipWrap.innerHTML = `
        <p class="cart-drawer__ship-text${done ? ' done' : ''}">
          ${done
            ? "<strong>You qualify for free shipping.</strong> Hell yeah."
            : `Add <strong>${left} more hat${left === 1 ? '' : 's'}</strong> to unlock free shipping.`}
        </p>
        <div class="cart-drawer__ship-bar">
          <span class="cart-drawer__ship-fill" style="width: ${pct}%"></span>
        </div>
      `;
    }

    const items = state.items || [];
    if (!items.length) {
      body.innerHTML = `
        <div class="cart-empty">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M6 7h12l-1.2 11.1a2 2 0 0 1-2 1.8H9.2a2 2 0 0 1-2-1.8L6 7Z"/>
            <path d="M9 7V5a3 3 0 0 1 6 0v2"/>
          </svg>
          <h3>Your cart is empty</h3>
          <p>Start filling it up with some party-ready trucker hats.</p>
          <a href="/">Shop All Hats</a>
        </div>
      `;
      foot.style.display = 'none';
      return;
    }

    foot.style.display = 'flex';
    body.innerHTML = items.map((line) => {
      const url = line.url || '#';
      const img = line.image || '';
      const title = line.product_title || line.title || '';
      const variantTitle = (line.variant_title && line.variant_title !== 'Default Title') ? line.variant_title : '';
      const linePrice = (line.final_line_price || line.line_price || line.price * line.quantity) / 100;
      const compareAt = (line.original_line_price || line.line_price) / 100;
      return `
        <div class="cart-line" data-key="${esc(line.key)}">
          <a class="cart-line__media" href="${esc(url)}" aria-label="${esc(title)}">
            <img src="${esc(img)}" alt="" />
          </a>
          <div class="cart-line__info">
            <h4 class="cart-line__title"><a href="${esc(url)}">${esc(title)}</a></h4>
            <p class="cart-line__meta">${variantTitle ? esc(variantTitle) + ' · ' : ''}Foam Trucker</p>
            <div class="cart-line__foot">
              <div class="cart-qty" role="group" aria-label="Quantity for ${esc(title)}">
                <button type="button" data-qty-dec aria-label="Decrease">−</button>
                <input type="text" value="${line.quantity}" data-qty-input inputmode="numeric" aria-label="Quantity" />
                <button type="button" data-qty-inc aria-label="Increase">+</button>
              </div>
              <div class="cart-line__price">
                <span class="cart-line__price-now">${fmt(linePrice)}</span>
                ${compareAt > linePrice ? `<span class="cart-line__price-was">${fmt(compareAt)}</span>` : ''}
              </div>
            </div>
            <button class="cart-line__remove" type="button" data-remove>Remove</button>
          </div>
        </div>
      `;
    }).join('');

    const subtotal = store.subtotal();
    const savings = store.savings();
    const qualifies = store.qualifiesForFreeShipping();
    const shipMsg = qualifies ? 'Free' : 'Calculated at checkout';
    foot.innerHTML = `
      <div class="cart-summary-row">
        <span>Subtotal</span>
        <span>${fmt(subtotal)}</span>
      </div>
      ${savings > 0 ? `
        <div class="cart-summary-row cart-summary-row--savings">
          <span>You saved</span>
          <span>− ${fmt(savings)}</span>
        </div>` : ''}
      <div class="cart-summary-row">
        <span>Shipping <small>· ships 2–3 biz days</small></span>
        <span>${shipMsg}</span>
      </div>
      <div class="cart-summary-row cart-summary-row--total">
        <span>Total</span>
        <span>${fmt(subtotal)}</span>
      </div>
      <div class="cart-drawer__actions">
        <a class="cart-drawer__view-cart" href="/cart">View Cart</a>
        <a class="cart-drawer__checkout" href="/checkout">Checkout</a>
      </div>
    `;
    bindLines();
  });

  function bindLines() {
    body.querySelectorAll('.cart-line').forEach((line) => {
      const key = line.getAttribute('data-key');
      const input = line.querySelector('[data-qty-input]');
      const dec = line.querySelector('[data-qty-dec]');
      const inc = line.querySelector('[data-qty-inc]');
      const removeBtn = line.querySelector('[data-remove]');

      const current = () => Math.max(1, parseInt(input.value, 10) || 1);
      dec?.addEventListener('click', () => store.setQty(key, current() - 1));
      inc?.addEventListener('click', () => store.setQty(key, current() + 1));
      input?.addEventListener('change', () => store.setQty(key, parseInt(input.value, 10) || 1));
      removeBtn?.addEventListener('click', () => store.remove(key));
    });
  }
})();
